<template lang="pug">
section
  s-page-title(title='Все категории')
    template(slot='extension')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    s-data-filter(@search='debouncedSearch' :initial='dataFilter.search')
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      :pagination='dataFilter'
      @update:pagination='updatePagination'
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item)')
          td {{ props.item.id }}
          td {{ props.item.name }}
          td {{ props.item.code }}
          td {{ props.item.goods_count }}
          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item)')
              v-icon(small) delete_outline
            s-publish-status-toggle(
              :value='props.item'
              @success='fetch'
              resource='shop/categories'
            )
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: true
      },
      {
        text: 'Название категории',
        align: 'left',
        sortable: true,
        value: 'name'
      },
      {
        text: 'Код категории',
        align: 'left',
        value: 'code',
        width: '0%',
        sortable: true
      },
      {
        text: 'Количество товаров в категории',
        align: 'left',
        value: 'goods_count',
        width: '0%',
        sortable: true
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ],
    sorting: {
      opened: false,
      resource: 'shop/categories',
      itemValue: 'id',
      itemText: 'name'
    }
  }),

  created() {
    this.fetch()
  },

  methods: {
    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    onEdit({ id } = {}) {
      this.$router.push({
        name: 'Shop.Categories.Edit',
        params: { id }
      })
    },

    fetch() {
      this.fetchList({
        config: {
          params: this.dataFilter
        }
      })
    },

    async onDelete({ id }) {
      if (await this.$confirm('Вы уверены?')) {
        try {
          await this.destroy({ id })
          this.fetch()
        } catch (e) {
          this.$root.showSnack('Ошибка удаления')
        }
      }
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('shop/categories', ['fetchList', 'destroy']),
    ...mapMutations('shop/categories', ['setDataFilter'])
  },

  computed: {
    ...mapState('shop/categories', ['total', 'dataFilter']),
    ...mapGetters('shop/categories', ['list', 'isLoading']),
  }
}
</script>
